import './details/details';
import './details/details-package';
import './details/details-accommodation';
import './details/details-travel';
import './details/details-fix';

$(() => {

    $('.btn-share').on('click', e => {
        const $target = $(e.currentTarget);
        const $shareWrapper = $target.parents('.share-wrapper');
        let shareShown = ! $shareWrapper.hasClass('show');
        $shareWrapper.toggleClass('show', shareShown);
    });
    
    $('[data-bs-toggle="modal"][data-bs-tab]').on('click', e => {
        const $target = $(e.currentTarget);
        const unitId = $target.attr('data-unitid');
        const $tab = $('#unitModal-' + unitId).find('[id=' + $target.attr('data-bs-tab') + ']');
        $tab.tab('show');
    });

    $('.summary-large-show').on('click', e => {
        const $target = $(e.currentTarget);
        const $summary = $('.summary-large');
        const isShowen = $summary.hasClass('show');
        $summary.toggleClass('show', ! isShowen);
        $target.text(isShowen ? $target.attr('data-show') : $target.attr('data-hide'));
    });

    /*const $detailsNav = $('#details-nav');

    $(window).on('scroll', e => {
        $detailsNav.toggleClass('show', window.scrollY > 200);
    });*/

    const $table = $('.table-responsive');
    const tableURL = $table.length ? $table.attr('data-tableurl') : null;

    if(tableURL) {
        let html = '';
        $.get(tableURL).done(response => {
            html = $(response).find('.entry-content').html();
            $table.html(html);
        });
    }

    if(! +$('.page-type-details').attr('data-dynamicpackage')) {
        const programURL = $('[data-programurl]').length ? $('[data-programurl]').attr('data-programurl') : null;
    
        if(programURL) {
            let html = '';
            $.get(programURL).done(response => {
                const $travelProgram = $(response).find('.entry-content');

                html = $travelProgram.find('.tab-pane[id="SopstveniPrevoz"]').html();

                $('#travelProgramModal').find('.modal-body').html(html);
                $('.travel-program-link').removeClass('d-none');
            }).fail(e => {
                $('.travel-program-link').addClass('d-none');
            });
        }
    }

    $('.btn-print-travel-program').on('click', e => {
        const $modalContent = $('#travelProgramModal').find('.modal-body');
        const modalContent = $modalContent[0];
        const $head = $('head');
        const head = $head[0];

        let htmlToPrint = head.outerHTML + '<style>@page { size:  auto; margin-top: 60px; margin-bottom: 60px; }</style>' + '<body>' + modalContent.outerHTML + '</body>';
        let windowToPrint = window.open("");

        windowToPrint.document.write(htmlToPrint);
        setTimeout(() => {
            windowToPrint.print();
            windowToPrint.close();
        }, 500);
    });

});